import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1710] text-[#D9C48A] mt-24 rounded-t-[2.5rem] overflow-hidden relative"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <img
              src="https://customer-assets-4nw71qhi.emergentagent.net/job_storici-hub/artifacts/uca8nbfn_Lista%20logo%20clienti%20%288%29%202.PNG"
              alt="Allevamento Colli Storici"
              className="h-16 w-auto bg-[#F5E6C0] rounded-xl p-1"
            />
            <div>
              <div className="font-serif text-2xl text-white leading-tight uppercase">
                Allevamento Colli Storici
              </div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-[#8B4A2B] font-bold mt-1">
                Obiettivo Pastore Tedesco
              </div>
            </div>
          </div>
          <p className="text-[#E8D9AC] leading-relaxed max-w-md">
            Passione, esperienza e servizi completi per il mondo degli animali.
            Allevamento di pastori tedeschi, toelettatura, pensione,
            alimentazione e negozio per animali e pesca.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-serif text-xl text-white mb-5">Pagine</h4>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-link-${n.to === "/" ? "home" : n.to.slice(1)}`}
                  className="text-[#E8D9AC] hover:text-white transition-colors link-underline"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-serif text-xl text-white mb-5">Contatti</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin className="w-5 h-5 text-[#8B4A2B] flex-none mt-0.5" />
              <a
                href={SITE.mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="text-[#E8D9AC] hover:text-white"
              >
                {SITE.address}
              </a>
            </li>
            <li className="flex gap-3">
              <Phone className="w-5 h-5 text-[#8B4A2B] flex-none mt-0.5" />
              <a
                href={`tel:${SITE.phoneRaw}`}
                data-testid="footer-phone"
                className="text-[#E8D9AC] hover:text-white"
              >
                {SITE.phoneDisplay} — Nicola
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-5 h-5 text-[#8B4A2B] flex-none mt-0.5" />
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="text-[#E8D9AC] hover:text-white"
              >
                {SITE.email}
              </a>
            </li>
            <li className="flex gap-3">
              <Clock className="w-5 h-5 text-[#8B4A2B] flex-none mt-0.5" />
              <span className="text-[#E8D9AC]">
                Su appuntamento — Aperto tutto l'anno
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#C4B489]">
          <p>
            © {new Date().getFullYear()} Allevamento Colli Storici — Tutti i
            diritti riservati.
          </p>
          <div className="flex items-center gap-6">
            <span className="hover:text-white cursor-pointer">Privacy Policy</span>
            <span className="hover:text-white cursor-pointer">Cookie Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
